import { useSelector, shallowEqual } from 'react-redux';
import { selectors, verifiers } from '@yola/subscription-manager-js';
import useFeatureFlags from 'yola-editor/src/js/modules/feature-flags/hooks/use-feature-flags';
import user from 'yola-editor/src/js/modules/user';

const { platformComponents } = user.constants;

export const extraPrices = {
  FREE_COM_DOMAIN: 'free_com_domain',
  NO_DISCOUNTS: 'no_discounts',
  ANNUAL_TRIAL_PACKAGE: 'annual_trial_package',
};

function useDomainsExtraPrice() {
  const subscriptionsList = useSelector(selectors.getSubscriptionList, shallowEqual);
  const activeSubscriptions = useSelector(selectors.getActiveSubscriptions, shallowEqual);
  const availablePlatformComponents = useSelector(
    user.selectors.getAvailablePlatformComponents,
    shallowEqual
  );
  const activeHostingSubscription = useSelector(selectors.getActiveHostingSubscription);

  const [featureFlags] = useFeatureFlags(['freedomain', 'free_trial_upsell']);
  const { freedomain: isFreeDomainFlagEnabled, free_trial_upsell: isFreeTrialUpsellEnabled } =
    featureFlags;
  const isDomainsPlatformAvailable = availablePlatformComponents.includes(
    platformComponents.DOMAINS
  );

  if (
    !subscriptionsList ||
    !activeSubscriptions ||
    !isDomainsPlatformAvailable ||
    (!isFreeDomainFlagEnabled && !isFreeTrialUpsellEnabled)
  )
    return null;

  const hasEverHadDomainSubscription = subscriptionsList.some(({ type }) =>
    verifiers.isDomainPackageType(type)
  );

  if (hasEverHadDomainSubscription) {
    return null;
  }

  const hasAnnualPaidHostingSubscription =
    verifiers.hasAnnualPaidHostingSubscription(activeSubscriptions);

  if (hasAnnualPaidHostingSubscription) {
    return extraPrices.NO_DISCOUNTS;
  }

  const subscriptionsTypes = subscriptionsList.map(({ type }) => type);
  const hasEverHadPaidHostingSubscription = verifiers.hasPaidHostingPackageType(subscriptionsTypes);
  const isActiveSubscriptionTrial =
    activeHostingSubscription && verifiers.isTrialSubscription(activeHostingSubscription);
  const isAnnualTrialPackageAvailable =
    (isFreeTrialUpsellEnabled && !hasEverHadPaidHostingSubscription) || isActiveSubscriptionTrial;

  if (isAnnualTrialPackageAvailable) {
    return extraPrices.ANNUAL_TRIAL_PACKAGE;
  }

  return extraPrices.FREE_COM_DOMAIN;
}

export default useDomainsExtraPrice;
